import { Dispatch, makeActionCreator, RootState } from "../../store/types";
import { history } from "../../store";
import { Product } from "../../models";
import { SuppInfoFormValues } from "./components/SuppInfoForm";
import { selectors as step1Selectors } from "../Step1";
import { selectors as styleSelectors } from "../WizardStyleChoice";
import { selectors as colorSelectors } from "../WizardColorChoice";
import { selectors as layoutSelectors } from "../WizardLayoutChoice";
import { selectors as step4Selectors } from "../Step4";
import * as selectors from "./selectors";
import * as wizardActions from "../Wizard/actions";

// Actions
export const SET_SUPP_FORM_VALUES = "step5/SET_SUPP_FORM_VALUES";
export const SET_SUBMIT_ERROR = "step5/SET_SUBMIT_ERROR";
export const RESET = "step5/RESET";
export const SET_SUBMITTING = "step5/SET_SUBMITTING";

// Action creators
const setSubmitError = makeActionCreator<
  string
>(SET_SUBMIT_ERROR as typeof SET_SUBMIT_ERROR);
export const setSuppFormValues = makeActionCreator<
  Partial<SuppInfoFormValues>
>(SET_SUPP_FORM_VALUES as typeof SET_SUPP_FORM_VALUES);
export const reset = makeActionCreator(RESET as typeof RESET);
const setSubmitting = makeActionCreator<
  boolean
>(SET_SUBMITTING as typeof SET_SUBMITTING);

// Thunks
// TODO: clean this mess
export const sendOrderRequest = () => async (
  dispatch: Dispatch,
  getState: () => RootState,
  http,
) => {
  dispatch(setSubmitting(true));

  const state = getState();

  // Step 1
  const product = step1Selectors.chosenProduct(state) as Product;

  // Step 2
  const customStyle = styleSelectors.descriptionValue(state);
  const selectedStyle = styleSelectors.selectedStyle(state);
  const styles: string[] = [];
  if (selectedStyle) {
    styles.push(selectedStyle.name);
  }
  if (customStyle) {
    styles.push(customStyle);
  }

  // Step 3
  const color = colorSelectors.chosenColor(state);

  // Step 4
  const projFormVals = step4Selectors.savedFormValues(state);
  const layout = layoutSelectors.chosenLayout(state);

  // Step 5
  const suppFormVals = selectors.savedFormValues(state);
  let specReq;
  if (suppFormVals.special_req) {
    specReq = suppFormVals.special_req.length ? suppFormVals.special_req : null;
  }

  const request = {
    // Step 1
    product_id: product.id,

    // Step 2
    style: styles || null,

    // Step 3
    is_color_fixed: colorSelectors.checkboxChecked(state),
    primary_color: color ? color.primary_color || null : null,
    secondary_color: color ? color.secondary_color || null : null,

    // Step 4
    unit_number: projFormVals.page_number ? projFormVals.page_number : null,
    dimension_height: projFormVals.dimension_height
      ? projFormVals.dimension_height
      : null,
    dimension_width: projFormVals.dimension_width
      ? projFormVals.dimension_width
      : null,
    dimension_depth: projFormVals.dimension_depth
      ? projFormVals.dimension_depth
      : null,
    layout_id: layout ? layout.id : null,
    industry_id: projFormVals.industry ? projFormVals.industry : null,
    content: projFormVals.content ? projFormVals.content : null,
    title: projFormVals.title ? projFormVals.title : null,
    audience: projFormVals.audience ? projFormVals.audience : null,
    material: projFormVals.material
      ? JSON.stringify(projFormVals.material)
      : null,

    // Step 5
    customer_name_first: suppFormVals.customer_name_first,
    customer_name_last: suppFormVals.customer_name_last,
    customer_phone:
      suppFormVals.customer_phone &&
      suppFormVals.customer_phone.replace(/\s+/g, ""),
    customer_email: suppFormVals.customer_email,
    has_express_req: suppFormVals.has_express_req === "true" ? true : false,
    has_vat: suppFormVals.vat === "true" ? true : false,
    payment_upfront:
      suppFormVals.has_payment_upfront === "true"
        ? suppFormVals.payment_upfront_rate
        : "0",
    special_req: specReq || null,
    additional_deliverable_number: suppFormVals.num_additional_designs
      ? suppFormVals.num_additional_designs
      : 0,

    // Misc
    has_overtime_req: false,
    redeem_code: suppFormVals.redeem_code || null,
  };

  try {
    const response: any = await http.post("data/orders", request);

    // Go to success page with token in state, if all good
    history.push("/order/success", response);

    // Reset all the wizard choices now that req was successful
    dispatch(wizardActions.resetWizard());
  } catch (error) {
    // TODO: somehow get this hooked up with redux-form error state (for 422 responses)
    dispatch(setSubmitError(error.message));
  } finally {
    dispatch(setSubmitting(false));
  }
};



// WEBPACK FOOTER //
// ./src/routes/Step5/actions.ts